import { useQuery } from "react-query";
import { queryGet } from "../../../utils/queryClient";

export default function useBuddyPreferenceQuery() {
  const { data: buddyPreference } = useQuery(
    ['MyBuddyPreferenceQuery'],
    () => queryGet('/api/v1/buddy_preferences/mine'),
    {
      select: (data) => data.buddyPreference
    }
  );
  return buddyPreference;
}
